import i18next from "i18next";
import { translateCuoTireTypeName } from "../../common/enums/cuoTireTypes.enum";

const t = (key: string, params?: object): string => i18next.t(key, { ns: "orders", ...params }) as string;

export const translateAdditionalInfo = (info: string): string => {
  if (!info) {
    return info;
  }

  const importMatch = info.match(/^Import z CUO - (.+?), pozycja (.+) (\d+)(?: \(=> (\d+) (.+)\))?$/);
  if (importMatch) {
    const [, number, tireType, quantity, convertedQuantity, convertedTireType] = importMatch;
    const params = {
      number,
      tireType: tireType === "Nieznany" ? t("cuoPanel.unknownTireType") : translateCuoTireTypeName(tireType),
      quantity,
      convertedQuantity,
      convertedTireType: convertedTireType ? translateCuoTireTypeName(convertedTireType) : "",
    };
    return convertedQuantity ? t("cuoPanel.importInfoConverted", params) : t("cuoPanel.importInfo", params);
  }

  const manualSplitMatch = info.match(/^Ręcznie podzielone zamówienie CUO - (.+)$/);
  if (manualSplitMatch) {
    return t("cuoPanel.manualSplitInfo", { number: manualSplitMatch[1] });
  }

  return info;
};
